<template>
  <div id="app">
      <div class="search-container">
        {{ success }}
        <input type="text" v-model="searchQuery" class="search" placeholder="Parole chiave">
        <input type="text" v-model="colorQuery" class="search" placeholder="Color">
        <button @click="fetchImages" class="button button-primary btn">Cerca</button>
      </div>
      <div v-if="images.total_results">
        {{ images.total_results }} risultati {{ images.page }} di {{ Math.round(images.total_results / images.per_page) }} Pagine
      
        <button v-if="images.page > 1" @click="fetchImages(images.page - 1)">Prev</button>
        <button v-if="Math.round(images.total_results / images.per_page) > images.page" @click="fetchImages(images.page + 1)">Next</button>

      </div>
      
      <div class="images" v-if="images.photos">
        <div class="image" v-for="image in images.photos" :key="image.id">
          <img :src="image.src.medium" alt="">
          <div class="actions" :style="`background-color:${image.avg_color}`">
              <a :href="image.src.original" :download="image.title" target="_blank" class="action button">Download</a>
              <button @click="saveImage(image)" class="action button button-primary">Salva</button>
              <button @click="setColor(image.avg_color)" class="action button">Cerca {{ image.avg_color }}</button>
          </div>
        </div>
      </div>

      <div class="savepopup" v-if="savepopup && image">
          <div v-if="loading" class="loading">
            Salvataggio... attendere
          </div>
          <template v-else>
          <img :src="image.src.medium">
          <div class="actions">
            <multiselect v-model="keywords" :taggable="true" :options="options" :multiple="true" :limit="2" label="slug" track-by="id" :close-on-select="true" placeholder="Seleziona Keywords">
            </multiselect>
            <hr/>
            <button @click="chiudiPopUp" class="button">Annulla</button>
            <button @click="uploadImage(image)" class="button button-primary">Salva</button>
          </div>
          </template>
      </div>
      <div class="overlay" v-if="savepopup && image">
      </div>
            
      <div v-if="error">
        {{error}}
      </div> 

  </div>
</template>

<script>
import axios from 'axios';
import Multiselect from 'vue-multiselect';

export default {
  name: 'Pexels',

  components: {
    Multiselect
  },

  data() {
    return {
      searchQuery: '',
      colorQuery: '',
      images: [],
      page: 1,
      error: '',
      success: '',
      loading: false,
      image: [],
      savepopup: false,
      keywords: [],
      options: []
    }
  },

  methods: {

    fetchKeywords() {
            axios
            .get(window["wpApiSettings"].root+'menaboh/v1/keywords')
            .then(response => (
                this.options = response.data
            )).catch((error) => {
            console.error(error)
          })
    },

    fetchImages: function(page) {

        const params = {
          query: this.searchQuery,
          color: this.colorQuery,
          per_page: 24,
          page: page ? page : this.page
        };

        //const token = '563492ad6f91700001000001fc7971f2932a40e081df20a917c8c0a2';
        const token = '563492ad6f91700001000001292c537f7a73441e83e6795930966831';
        axios.get('https://api.pexels.com/v1/search', {
          params,
          headers: {
            'Authorization': token
          }
        })
        .then((response) => {
          this.images = response.data
        })
        .catch((error) => {
          console.error(error)
        })
    },

    search: function() {
      this.fetchImages();
    },

    setColor: function(c) {
        this.colorQuery = c;
        this.fetchImages();
    },

    saveImage: function(image) {
      this.savepopup = true;
      this.image = image;
    },

    chiudiPopUp: function() {
      this.image = [],
      this.savepopup = false
    },

    uploadImage: function(image) {
        console.log(image);
        this.loading = true
        const params = {
          title: image.id,
          immagine: image.src.original,
          keywords: this.keywords
        };

        axios
        .post(window["wpApiSettings"].root+'menaboh/v1/images',  params,
        {
            headers: { 
              'content-type': 'application/json',
              'X-WP-Nonce': window["wpApiSettings"].nonce
            }
        } )
        .then(response => (
            this.success = response.data,
            this.savepopup = false,
            this.image = false,
            this.loading = false
        ))

    }

  },

  mounted() {
    this.fetchKeywords();
  }
}
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.savepopup {
  background: white;
  width: 300px;
  height: 480px;
  position: fixed;
  z-index: 99;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-items: center;
  flex-direction: column;
  padding: 1rem;
  border-radius: 3px;

  img {
    max-width: 100%;
    margin-bottom: auto;
  }
  
  .loading {
    margin: auto
  }

  .actions {
    margin-top: auto;
  }
}

.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba($color: #000000, $alpha: 0.3);
  z-index: 98;
}


.search-container {
  display: flex;
  justify-content: center;
  flex-direction: row;

  input {
  margin: 5px;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }

  .search {
    padding: 0.5rem 0.75rem;
    font-size: 1.25rem;
    font-weight: bold;
    text-align: center;
  }


  .btn {
    padding: 0.5rem 0.75rem;
    font-size: 1.25rem;
    outline: 0;
  }

}

.images {
  margin: 2rem auto 1rem auto;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.image {
  flex: 1 1 200px;
  position: relative;
}

.image img {
  width: 100%;
}

.image .actions {
    display: none;
    position: absolute;
    z-index: 2;
    bottom: 10px;
}

.image:hover .actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;
  width: 100%;

  .action {
    margin: 0.25rem;
    padding: 0.25rem;
  }
}
</style>